import React, { useEffect, useState } from "react";
import Table from "../shared/table/Table";
import { FiEdit3 } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchFormData,formatDateOnly } from "../../utils/options";
import { MdThumbDown, MdThumbUp } from "react-icons/md";
import topTost from "../../utils/topTost";
import Swal from "sweetalert2";

const NotesTable = ({ filteredData = null, permission }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");
  const [branchData, setBranchData] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const fetchbranchData = async () => {
    try {
      Swal.fire({
        title: "Loading notes...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const formData = new FormData();
      formData.append("userId", userId);
      formData.append("moduleId", M_id);

      const result = await fetchFormData("note/getAll", formData, "POST");

      if (result) {
        const branch = result.data || [];
        branch.sort((a, b) => {
          const nameA = a?.name || "";
          const nameB = b?.name || "";
          return nameA.localeCompare(nameB);
        });

        setBranchData(branch);
      }
    } catch (error) {
      console.error("Error fetching notes data:", error);

    } finally {
      Swal.close();
    }
  };

  const toggleStatus = async (Id) => {
    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("moduleId", M_id);
    const result = await fetchFormData(
      `note/toggle-status/${Id}`,
      formData,
      "POST"
    );

    if (result && result.code === 200) {
      await fetchbranchData();
      if (result?.status === 1) {
        topTost({
          title: "Status updated successfully: Active",
          icon: "success",
        });
      } else {
        topTost({
          title: "Status updated successfully: Deactive",
          icon: "success",
        });
      }
    } else {
      topTost({
        title: result.message,
        icon: "success",
      });
    }
  };

  const columns = [
    ...(permission?.pf_edit === 1 || permission?.pf_status === 1
      ? [
        {
          accessorKey: "actions",
          header: () => "Actions",
          cell: ({ row }) => {
            const id = row.original.id;
            const is_active = row.original.status;
            return (
              <div className="hstack gap-2 justify-content-end">
                {permission?.pf_edit === 1 && (
                  <span
                    className="cursor-pointer"
                    onClick={() =>
                      navigate(`/master/edit-notes/${id}?id=${M_id}`)
                    }
                  >
                    <FiEdit3 size={16} />
                  </span>
                )}
                {permission?.pf_status === 1 &&
                  (is_active === 1 ? (
                    <MdThumbUp
                      className="cursor-pointer text-success"
                      onClick={() => toggleStatus(id)}
                    />
                  ) : (
                    <MdThumbDown
                      className="cursor-pointer text-secondary"
                      onClick={() => toggleStatus(id)}
                    />
                  ))}
              </div>
            );
          },
          meta: {
            headerClassName: "width-30",
            exportable: false,
          },
        },
      ]
      : []),
    {
      accessorKey: "title",
      header: () => "Title",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "typename",
      header: () => "Note type",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "description",
      header: () => "Description",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "created_at",
      header: () => "Created Date",
       cell: (info) => formatDateOnly(info.getValue()),
      defaultIsVisible: true,
    },
    {
      accessorKey: "status",
      header: () => "Status",
      cell: (info) => {
        const val = info.getValue(); // expected to be 1 or 0 (number)
        const isActive = val === 1;

        const label = isActive ? "Active" : "Deactive";
        const styles = {
          backgroundColor: isActive ? "#cce5ff" : "#fff3cd", // Sky blue / Light yellow
          color: isActive ? "#004085" : "#856404", // Dark blue / Dark yellow
          padding: "4px 10px",
          display: "inline-block",
          fontWeight: "bold",
          fontSize: "12px",
          textAlign: "center",
        };

        return <span style={styles}>{label}</span>;
      },
      defaultIsVisible: true,
    },
  ];


  useEffect(() => {
    const shouldFetch =
      !Array.isArray(filteredData) || filteredData.length === 0;

    if (shouldFetch) {
      fetchbranchData();
    } else {
      setBranchData(filteredData); 
    }
  }, [filteredData]);
  return (
    <>
      <Table data={branchData} columns={columns} />
    </>
  );
};

export default NotesTable;
